import type { AnyAction } from "redux";

import {
  FETCH_INDUSTRIES_SUCCESS,
  FETCH_POPULAR_LOCATION_OPTIONS_SUCCESS,
  FORCE_PAGE_REMOUNT,
  HIDE_LEFT_SIDEBAR,
  SET_ACTIVE_MESSENGER_ROOM,
  SET_LAYOUT_BG_COLOR,
  SHOW_LEFT_SIDEBAR,
} from "@js/apps/common/action-types";
import type { CommonState } from "@js/types/common";

const INITIAL_STATE: CommonState = {
  appLayoutKey: 1,

  showLeftSidebar: true,

  layoutBgColor: undefined,

  industries: [],

  popularLocations: [],

  activeMessengerRoom: undefined,
};

export default function (
  state = INITIAL_STATE,
  action: AnyAction,
): CommonState {
  switch (action.type) {
    case FORCE_PAGE_REMOUNT:
      return { ...state, appLayoutKey: state.appLayoutKey + 1 };

    case SHOW_LEFT_SIDEBAR:
      return {
        ...state,
        showLeftSidebar: true,
      };

    case HIDE_LEFT_SIDEBAR:
      return {
        ...state,
        showLeftSidebar: false,
      };

    case SET_LAYOUT_BG_COLOR:
      return {
        ...state,
        layoutBgColor: action.payload,
      };

    case FETCH_POPULAR_LOCATION_OPTIONS_SUCCESS:
      return { ...state, popularLocations: action.payload };

    case FETCH_INDUSTRIES_SUCCESS:
      return { ...state, industries: action.payload };

    case SET_ACTIVE_MESSENGER_ROOM:
      return { ...state, activeMessengerRoom: action.payload.roomId };

    default:
      return state;
  }
}
